// 手动关闭会话（用户主动关闭）
export const MANUAL_CLOSE_CODE = 1000;
// export const MANUAL_CLOSE_CODE = 1000;

export enum SocketErrorCode {
  AuthenticationFailed = 4000,
  SessionExpired = 4001,
  BlackList = 4002,
  ManagerForceOutLine = 4003,
  LoggedInOtherPlace = 4005,
  CancelLineUpByUser = 4010,
  CloseChatByUser = 4011,
  // 排队超时
  LineUpTimeout = 4012,
  // 会话超时
  ChatTimeout = 4013,
  CloseChatByAgent = 4014,
  // 客服不在工作时间
  AgentOutOfService = 4015,
  // 服务异常
  ServiceError = 4500,
  // 消息太大
  MessageTooBig = 4501,
  // 服务限流
  ServiceLimitStream = 4502,
  // 业务异常
  BusinessError = 4505,
}

export const CONNECT_PATH = "/liveChat/";

/**
 * 连接WebSocket的渠道信息
 */
export enum SOCKET_CONNECT_CHANNEL {
  // 海外handy
  HANDY_OR = "handy-en",
  // 国内handy
  HANDY_CN = "handy-cn",
  // 国内其他
  OTHERS_CN = "others-cn",
  // 海外其他
  OTHERS_OR = "others-en",
}

export const HistoryLimit = 10;

export const SEND_TYPING_INTERVAL = 1000;
export const STOP_TYPING_DELAY = 1000;
